"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isValid = function (value) {
    var errors = {
        hasSpecialCaracteres: 'O Nome do negócio não pode conter caracteres especiais',
        hasOnlyNumbers: 'O Nome do negócio não pode conter apenas números.',
    };
    var HAS_ONLY_ALLOWED_CARACTERES = /^[0-9a-zA-ZâÂàÀáÁãÃêÊèÈéÉîÎìÌíÍõÕôÔòÒóÓüÜûÛúÚùÙçÇ'& ]*$/.test(value);
    var HAS_ONLY_NUMBERS_REGEX = /^[0-9]+$/.test(value);
    if (HAS_ONLY_NUMBERS_REGEX || !HAS_ONLY_ALLOWED_CARACTERES) {
        return {
            hasError: true,
            message: HAS_ONLY_NUMBERS_REGEX
                ? errors.hasOnlyNumbers
                : errors.hasSpecialCaracteres,
        };
    }
    return {
        hasError: false,
        message: '',
    };
};
var validateBussinessName = function (value) {
    var validationResult = isValid(value);
    if (validationResult.hasError)
        return validationResult.message;
    return false;
};
exports.default = validateBussinessName;
//# sourceMappingURL=bussinessName.js.map